<template>
  <div class="w-full">
    <NavigationView />
    <div class="relative pb-2">
      <div class="relative">
        <div
          class="bg-gradient-to-b from-[#05225E] to-[#183883] hidden md:inline-block md:h-[520px] lg:min-h-[550px] 2xl:min-h-[615px] w-full -z-10 rounded-b-3xl md:rounded-b-[40px]">
        </div>
      </div>

      <section class="w-full max-w-7xl mx-auto md:p-4 lg:p-0">
        <!-- Mobile Banner -->
        <div class="md:hidden">
          <div class="text-left px-5 rounded-full">
            <div class="absolute text-sm text-white">
              <div>
                <ul class="breadcrumb flex">
                  <li v-for="(item, index) in b_value" :key="index" :class="{
                    'breadcrumb-item': !isActive(index),
                    'active-breadcrumb-item': isActive(index),
                  }">
                    <span :class="{ 'breadcrumb-text': !isActive(index) }">
                      <a :href="item.link" class="text-[10px]">
                        {{ item.text }}
                      </a>
                    </span>
                    <span v-if="index < b_value.length - 1" class="breadcrumb-arrow">
                      >
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="m-auto">
            <img :src="Programs.mobile_banner" alt="Banner.webp" class="opacity-100 w-full h-full" />
            <div class="w-full h-full absolute top-0 bg-gradient-to-b from-[#ffffff] to-[#1E387E] bg-opacity-0 -z-10">
            </div>
          </div>
          <div class="bg-gradient-to-b from-[#4B61BE] to-[#001C54] rounded-b-2xl pb-6 mb-8 px-5">
            <h2 class="absolute h1 bottom-[60%] text-start font-bold w-[22rem] text-white">
              {{ Programs.name }}
            </h2>
            <p class="pt-[1rem] text-white m-auto text-start text-[14px]" v-html="Programs.description"></p>
            <p class="mt-[1rem] text-left text-[14px] font-bold text-white">
              Start upskilling at just
              {{ formatCurrency(Programs.upskill_payment) }} per month.
            </p>
            <div class="py-4">
              <div class="flex justify-around mt-4">
                <div class="flex items-center gap-2">
                  <div>
                    <img src="@/assets/elective/multimedia.png" alt="multimediaContent" />
                  </div>
                  <p class="text-white w-[5rem] text-xs font-bold text-start">
                    {{ Programs.upskill_desc_one }}
                  </p>
                </div>
                <div class="flex items-center gap-2">
                  <div>
                    <img src="@/assets/elective/courses.png" alt="courses" />
                  </div>
                  <p class="text-white w-[5rem] text-xs font-bold text-start">
                    {{ Programs.upskill_desc_two }}
                  </p>
                </div>
              </div>
              <div class="flex justify-around mt-4">
                <div class="flex items-center gap-2">
                  <div>
                    <img src="@/assets/elective/faculty.png" alt="multimediaContent" />
                  </div>
                  <p class="text-white w-[5rem] text-xs font-bold text-start">
                    {{ Programs.upskill_desc_three }}
                  </p>
                </div>
                <div class="flex items-center gap-2">
                  <div>
                    <img src="@/assets/elective/glove.svg" alt="multimediaContent" />
                  </div>
                  <p class="text-white w-[5rem] text-xs font-bold text-start">
                    {{ Programs.upskill_desc_four }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <a target="blank" class="flex justify-center items-center">
            <button @click="handleApplyNowClick"
              class="rounded-3xl bg-[#F8C300] text-[16px] w-[155px] absolute bottom-[3%] py-[13px] button-cta">
              Apply now
            </button>
          </a>
        </div>
        <!-- Desktop Banner -->
        <div
          class="hidden w-full max-w-7xl md:flex md:flex-row mx-auto gap-[10px] absolute top-0 md:h-[560px] lg:min-h-[550px]"
          v-if="this.Programs">
          <div class="md:w-1/2 px-5 py-2 lg:pb-6 2xl:pb-8 text-left text-white">
            <div class="flex flex-col gap-[10px]">
              <div class="hidden md:block">
                <div>
                  <ul class="breadcrumb flex gap-2">
                    <li v-for="(item, index) in b_value" :key="index" :class="{
                      'breadcrumb-item': !isActive(index),
                      'active-breadcrumb-item': isActive(index),
                    }">
                      <span :class="{ 'breadcrumb-text': !isActive(index) }">
                        <a :href="item.link">{{ item.text }}</a>
                      </span>
                      <span v-if="index < b_value.length - 1" class="breadcrumb-arrow">
                        >
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <h1 class="text-[22px] lg:text-[26px] 2xl:text-[36px] font-semibold">
                Online {{ Programs.short_name }}
                <br />
                {{ Programs.name }}
              </h1>
              <p class="text-[14px] lg:text-[16px] w-[20rem] lg:w-[25rem] xl:w-[30rem]" v-html="Programs.description">
              </p>
              <p class="text-[14px] lg:text-[18px] font-semibold">
                Start upskilling at just
                {{ formatCurrency(Programs.upskill_payment) }} per month.
              </p>
              <div class="border-b-[1px] border-silver-100 w-[20rem] lg:w-[30rem] mt-2"></div>
              <div class="xl:ml-0 xl:pt-[2rem] w-[20rem] lg:w-[25rem] xl:w-[30rem]">
                <div class="flex justify-between">
                  <div class="flex items-center lg:w-[13rem]">
                    <img src="@/assets/elective/multimedia.png" alt="multimediaContent" />

                    <p class="text-white w-[5rem] lg:w-max text-xs xl:text-base font-bold text-start pl-2">
                      {{ Programs.upskill_desc_one }}
                    </p>
                  </div>
                  <div class="flex items-center lg:w-[13rem]">
                    <img src="@/assets/elective/courses.png" alt="courses" />

                    <p class="text-white w-[5rem] lg:w-max text-xs xl:text-base font-bold text-start pl-2">
                      {{ Programs.upskill_desc_two }}
                    </p>
                  </div>
                </div>
                <div class="flex justify-between mt-4 mb-4 lg:mt-8">
                  <div class="flex items-center lg:w-[13rem]">
                    <img src="@/assets/elective/faculty.png" alt="multimediaContent" />

                    <p class="text-white w-[5rem] lg:w-max text-xs xl:text-base font-bold text-start pl-2">
                      {{ Programs.upskill_desc_three }}
                    </p>
                  </div>
                  <div class="flex items-center lg:w-[13rem]">
                    <img src="@/assets/elective/glove.svg" alt="multimediaContent" />

                    <p class="text-white w-[5rem] lg:w-max text-xs xl:text-base font-bold text-start pl-1">
                      {{ Programs.upskill_desc_four }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full lg:h-[600px] 2xl:h-[650px] md:w-1/2 relative">
            <img :src="Programs.banner" alt="" class="h-full w-full rounded-b-[30px] object-Contain" />
          </div>
        </div>
      </section>
      <div
        class="hidden md:block absolute bottom-[-12px] md:bottom-[22px] lg:bottom-[-5px] md:left-14 lg:left-[7%] 2xl:left-[25%]">
        <a target="blank">
          <button class="w-[155px] py-[13px] rounded-full text-[#001c54] bg-[#F8C300] button-cta"
            @click="handleApplyNowClick">
            Apply now
          </button>
        </a>
      </div>
    </div>

    <div class="hidden md:block w-full md:h-2 lg:h-16"></div>
  </div>
</template>

<script>
import axios from "axios";
import NavigationView from "@/components/NavigationView.vue";
export default {
  name: "ElectiveBanner",
  components: {
    NavigationView,
  },
  data() {
    return {
      b_value: [
        { text: "Home", link: "/" },
        { text: "", link: "/all-programs/" },
        { text: "", link: "" },
      ],
      Programs: {},
    };
  },

  async created() {
    await this.programCall();
    await this.trackingElectiveUser();
  },

  props: ["program"],

  methods: {
    async programCall() {
      const slug = this.$route.params.slug;
      const apiUrl = `${process.env.VUE_APP_API}/course/program-list/?slug=${slug}`;

      try {
        const resp = await axios.get(apiUrl);

        if (resp.data.status === 200 && resp.data.data.length > 0) {
          this.Programs = await resp.data.data[0];
          this.updateBreadcrumbs();
          // this.trackingElectiveUser();
          let noOfElectives = "";
          if (
            this.Programs.name === "Master of Business Administration (MBA)"
          ) {
            noOfElectives = 22;
          } else if (this.Programs.name === "Master of Commerce (M.Com)") {
            noOfElectives = 3;
          } else if (
            this.Programs.name === "Master of Computer Application (MCA)"
          ) {
            noOfElectives = 7;
          } else if (this.Programs.name === "Bachelor of Commerce (B.Com)") {
            noOfElectives = 3;
          } else if (
            this.Programs.name === "Bachelor of Business Administration (BBA)"
          ) {
            noOfElectives = 6;
          } else if (this.Programs.name === "Master of Arts (M.A)") {
            noOfElectives = 3;
          }

          const programDescription = this.Programs.description.replace(
            /<[^>]*>/g,
            ""
          );

          // Push data to dataLayer
          dataLayer.push({
            "event": "Program Viewed",
            "Attribute": {
              "Program Title": this.Programs.name,
              "Program ID": this.Programs.id.toString(),
              "No of Electives": noOfElectives,
              "Domain": this.Programs.category.name,
              "Domain ID": this.Programs.category.id.toString(),
              "Program Details": programDescription,
            },
          });
        } else {
          console.log("Program not found");
          this.$router.push({
            name: "PageNotFound",
            params: { pathMatch: "page-not-found" },
          });
        }
      } catch (error) {
        console.error("Error fetching program:", error);
      }
    },
    async trackingElectiveUser() {
      if (window.location.origin === "https://onlinejain.com") {
        let trackingData = {
          program_name: this.$route.params.slug,
          program_url: `${window.location.origin}${window.location.pathname}`,
          utm_campaign: this.$route.query.utm_campaign || "",
          utm_source: this.$route.query.utm_source || "",
          utm_medium: this.$route.query.utm_medium || "",
          utm_adgroup: this.$route.query.utm_adgroup || "",
          utm_adgroupid: this.$route.query.utm_adgroupid || "",
          utm_matchype: this.$route.query.utm_matchype || "",
          utm_location: this.$route.query.utm_location || "",
          utm_keyword: this.$route.query.utm_keyword || "",
          utm_device: this.$route.query.utm_device || "",
          utm_devicemodel: this.$route.query.utm_devicemodel || "",
          utm_placement: this.$route.query.utm_placement || "",
          utm_target: this.$route.query.utm_target || "",
          utm_term: this.$route.query.utm_term || "",
          utm_network: this.$route.query.utm_network || "",
          utm_creative: this.$route.query.utm_creative || "",
          utm_creativeid: this.$route.query.utm_creativeid || "",
          utm_campaignid: this.$route.query.utm_campaignid || "",
          gclid: this.$route.query.gclid || "",
          // ip: https://api.ipify.org?format=json || "",
        };
        await axios
          .post(
            `${process.env.VUE_APP_API}/program-tracking-create/`,
            trackingData
          )
          .then((resp) => {
            if (resp) {
              console.log("Post method request : ", resp);
            }
          })
          .catch((err) => {
            console.log("post method is not posted : ", err);
          });
      }
    },
    updateBreadcrumbs() {
      if (this.Programs && this.Programs.name) {
        this.b_value[this.b_value.length - 1] = {
          text: this.Programs.short_name,
          link: "",
        };
        this.b_value[this.b_value.length - 2] = {
          text: this.Programs.category.name,
          link: "/all-programs/",
        };
      }
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      }).format(value);
    },
    isActive(index) {
      return index === this.b_value.length - 1;
    },
    handleApplyNowClick() {
      dataLayer.push({
        "event": "Apply Online Initiated",
        "Attribute": {
          "CTA": "Apply Now",
          "Section Name": "Programpage Banner",
        },
      });
      window.open("https://apply.onlinejain.com/", "_blank");
    },
  },
};
</script>

<style>
.h1 {
  font-size: 24px;
}
</style>
